import { FEATURE_FLAGS } from 'utils/constants';
import { useFeatureFlagContext } from 'v2/context/featureFlagContext';

export function useFeatureFlags(flagsToTest: FEATURE_FLAGS[]): boolean[] {
  const { flags } = useFeatureFlagContext();
  return flagsToTest.map((f) => flags[f]);
}
